import { lazy } from "react";

const PopupPage = lazy(() => import("./main"));
const CreatePopupPage = lazy(() => import("./create"));
const UpdatePopupPage = lazy(() => import("./update"));

export { PopupPage, CreatePopupPage, UpdatePopupPage };
